export const commonTr = {
  nav: {
    story: 'Hikayemiz',
    community: 'Topluluk',
    transformation: 'Dönüşüm',
    safety: 'Güvenlik',
    blog: 'Blog',
    shop: 'Mağaza',
    donate: 'Destek',
    volunteer: 'Gönüllü',
    resources: 'Kaynaklar',
    crisisTracker: 'Kriz Takipçisi',
    partners: 'Ortaklar',
    successStories: 'Başarı Hikayeleri',
  },
  // Navigation
  home: "Ana Sayfa",
  myStory: "Hikayem",
  community: "Topluluk",
  shop: "Mağaza",
  blog: "Blog",
  
  // Common buttons
  readMore: "Devamını Oku",
  learnMore: "Daha Fazla Bilgi",
  joinNow: "Şimdi Katıl",
  shopNow: "Şimdi Alışveriş Yap",
  subscribe: "Abone Ol",
  submit: "Gönder",
  
  // Footer
  quickLinks: "Hızlı Bağlantılar",
  contact: "İletişim",
  followUs: "Bizi Takip Edin",
  allRightsReserved: "Tüm hakları saklıdır",
  
  // Newsletter
  newsletterTitle: "Topluluğumuza Katılın",
  newsletterSubtitle: "Haftalık ilham ve güncellemeleri e-postanızda alın",
  emailPlaceholder: "E-postanızı girin",
  
  // Common phrases
  byAuthor: "Yazar"
};

export default commonTr;
